<template>
  <div class="container report">
    <div class="searchCondition">
      <span class="utc">UTC-0</span>
      <el-date-picker
        v-model="where.date"
        type="daterange"
        :default-time="['00:00:00', '23:59:59']"
        :clearable="false"
        start-placeholder="from"
        end-placeholder="to"
        size="mini"
      >
      </el-date-picker>
      <el-input
        v-model="where.offerid"
        style="width: 300px"
        placeholder="Offer id"
        clearable
        size="mini"
      ></el-input>
      <el-button size="mini" @click="search">Search</el-button>
      <exportcsv :rows="rows" filename="Report" :tableObj="$refs.table"></exportcsv>
      <!-- <div class="tip"><span style="font-size">Revenue Total:</span> ${{ revenueTotal }}</div> -->
    </div>
    <el-table
      :data="rows"
      height="250"
      border
      stripe
      class="table"
      v-loading="loading"
      header-row-class-name="table-header"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      ref="table"
    >
      <el-table-column prop="offerid" label="Offer Id" width="130">
      </el-table-column>
      <el-table-column prop="offer_name" label="Offer Name" width="420">
      </el-table-column>
      <el-table-column label="Clicks">
        <el-table-column prop="click" :label="summary.click || '--'"> </el-table-column>
      </el-table-column>
      <el-table-column label="Convers">
        <el-table-column prop="sent_conv" :label="summary.sent_conv || '--'"> </el-table-column>
      </el-table-column>
      <el-table-column label="CVR">
        <el-table-column prop="sent_cvr" :label="summary.sent_cvr || '--'"> </el-table-column>
      </el-table-column>
      <el-table-column label="Price($)">
        <el-table-column prop="avg_payout" :label="summary.avg_payout || '--'"> </el-table-column>
      </el-table-column>
      <el-table-column label="Revenue($)">
        <el-table-column prop="cost"  :label="summary.cost || '--'"> </el-table-column>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-left: 30px"
      layout="total,sizes,prev, pager, next"
      :total="total"
      :current-page.sync="page"
      @current-change="search"
      :page-size.sync="limit"
      @size-change="search"
      :page-sizes="[20,50,100]"
    >
    </el-pagination>
  </div>
</template>
<script>
import { post } from "@/lib/channelClient";
import exportcsv from '@/components/channelClient/exportcsv.vue';
export default {
	components:{
		exportcsv,
	},
	data() {
	
		return {
			where: {
				date: [
					new Date(new Date().setHours(0, 0, 0, 0)),
					new Date(new Date().setHours(23, 59, 59, 0)),
				],
			},
			rows: [],
      summary: {},
			total: 0,
			limit: 20,
			page: 1,
			revenueTotal: 0,
			loading: false,
		};
	},
	mounted() {
		this.search();
	},
	methods: {
		async search() {
			await new Promise((res) => setTimeout(res, 0));
			const where = this.where;
			const bias = new Date().getTimezoneOffset() * 60;
			where.time = {
				$gte: where.date[0].getTime() / 1000 - bias,
				$lt: where.date[1].getTime() / 1000 - bias,
			};
			const limit = this.limit;
			const offset = (this.page - 1) * limit;
			this.loading = true;
			const res = await post("/channelClient/report", { where, limit, offset });
			this.loading = false;
			if (res.status != 200) {
				const text = await res.text();
				if (/login/.test(text)) {
					window.location.href = "/login";
					return;
				}
				this.$message.error({ message: text, duration: 1500 });
				return;
			}
			const body = await res.json();
			this.rows = body.rows;
      this.summary = body.summary;
			this.total = body.count;
			this.revenueTotal = body.summary.cost;
		},
		async pageChange(page) {
			this.page = page;
			await this.search();
		},
	},
};
</script>
<style scoped>


.header {
  display: flex;
  align-items: center;
  background-color: #495668;
  color: white;
  height: 40px;
}

.searchCondition {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
}
.tip {
  margin-left: 30px;
  height: 40px;
}

.table {
  margin-bottom: 20px;
}
</style>
